import { getSessionCookie, setSessionCookie, SessionData } from './cookie';
import { IFetchData, IDownloadFile } from '../_types/post';
import { IUserDataCookie } from '../_types/jwt';
import { trackPromise } from 'react-promise-tracker';

export const APIGet = async <T, >(request: IFetchData): Promise<T | null> => {

    //let relayPost: IFetchData = { app_ver: "", method:"GET", relay_to: url };
    request.method = "GET";

    
    let result: T | null = await APIPost(request );

    return result;
}

export const Download = async (post: IFetchData, fileName: string): Promise<IDownloadFile | null> => {

    let dtNow = new Date();
    let myCookie: SessionData | null = getSessionCookie();
    let toReturn: IDownloadFile | null = null;
    let headers = new Headers();

    if (fileName == null || fileName.length === 0) {
        fileName = "download.csv";
    }

    //if needs auth, check jwt expire first
    if (post.authorize) {
        if (!myCookie || myCookie.GetJwtExpiresAt() < dtNow) {
            //should throw a 401 error here.
            return toReturn;
        } else {
            headers = new Headers(myCookie.GetJwtHeader());
        }
    }
    
    headers.append('Content-Type', 'application/json');
    headers.append('x-app-ver', 'insight|102');
    //base url from config
    const api_url = process.env.REACT_APP_API_URL;
    const full_url = api_url + "/2/proxy_download";
    
    if (!post.method) {
        post.method = "POST"; //this is the method that php will use to relay to dotnet
    }

    const postData = JSON.stringify(post);

    //execute fetch
    const data = await trackPromise(fetch(
        full_url,
        {
            method: 'POST',
            headers: headers,
            body: postData,
            cache: 'no-cache',
            mode: 'cors'
        }));

    if (data.ok) {

        if (data) {

            // const keys = headers.keys();
            // let header = keys.next();
            // while (header.value) {
            //     console.log(console.log(header.value), headers.get(header.value));
            //     header = keys.next();
            // }

            let cd = data.headers.get('content-disposition');
 
            if (cd && cd.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(cd);
                if (matches != null && matches[1]) { 
                  fileName = matches[1].replace(/['"]/g, '');
                }
            }


            toReturn = {
                fileName: `${fileName}`,
                contents: await data.blob() as any
            };

            let jwt = data.headers.get('authorization');

            if (jwt) {
                jwt = jwt.replace('Bearer ', '');

                if (myCookie) {
                    myCookie.setJwt(jwt);
                    setSessionCookie(myCookie);
                } else {
                    let newCookie: IUserDataCookie = { jwt: jwt };
                    myCookie = new SessionData(newCookie)
                    setSessionCookie(myCookie);
                }
            }
            
        }
        
        
    }
    
    return toReturn;
}

export const Stream = async (post: IFetchData, fileName: string): Promise<IDownloadFile | null> => {

    let dtNow = new Date();
    let myCookie: SessionData | null = getSessionCookie();
    let toReturn: IDownloadFile | null = null;
    let headers = new Headers();

    if (fileName == null || fileName.length === 0) {
        fileName = "download.csv";
    }

    //if needs auth, check jwt expire first
    if (post.authorize) {
        if (!myCookie || myCookie.GetJwtExpiresAt() < dtNow) {
            //should throw a 401 error here.
            return toReturn;
        } else {
            headers = new Headers(myCookie.GetJwtHeader());
        }
    }
    
    headers.append('Content-Type', 'application/json');
    headers.append('x-app-ver', 'insight|102');
    //base url from config
    const api_url = process.env.REACT_APP_API_URL;
    const full_url = api_url + "/2/proxy_stream_query";
    
    if (!post.method) {
        post.method = "POST"; //this is the method that php will use to relay to dotnet
    }

    const postData = JSON.stringify(post);

    //execute fetch
    const data = await trackPromise(fetch(
        full_url,
        {
            method: 'POST',
            headers: headers,
            body: postData,
            cache: 'no-cache',
            mode: 'cors'
        }));

    if (data.ok) {

        if (data && data.headers && data.headers.get('authorization')) {

            // const keys = headers.keys();
            // let header = keys.next();
            // while (header.value) {
            //     console.log(console.log(header.value), headers.get(header.value));
            //     header = keys.next();
            // }

            let cd = data.headers.get('content-disposition');
 
            if (cd && cd.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(cd);
                if (matches != null && matches[1]) { 
                  fileName = matches[1].replace(/['"]/g, '');
                }
            }


            toReturn = {
                fileName: `${fileName}`,
                contents: await data.blob() as any
            };

            let jwt = data.headers.get('authorization');

            if (jwt) {
                jwt = jwt.replace('Bearer ', '');

                if (myCookie) {
                    myCookie.setJwt(jwt);
                    setSessionCookie(myCookie);
                } else {
                    let newCookie: IUserDataCookie = { jwt: jwt };
                    myCookie = new SessionData(newCookie)
                    setSessionCookie(myCookie);
                }
            }
            
        }
        
        
    }
    
    return toReturn;
}

export const APIPost = async <T, >(post: IFetchData, abort?: AbortController): Promise<T | null> => {

    let dtNow = new Date();
    let myCookie: SessionData | null = getSessionCookie();
    let toReturn: T | null = null;
    let headers = new Headers();

    if (!abort) { 
        abort = new AbortController();
        console.log('abort controller created')
    }

    //if needs auth, check jwt expire first
    if (post.authorize) {
        if (!myCookie || myCookie.GetJwtExpiresAt() < dtNow) {
            //should throw a 401 error here.
            return toReturn;
        } else {
            headers = new Headers(myCookie.GetJwtHeader());
        }
    } else { //if we have the cookie, we should use it
        if (myCookie && myCookie.GetJwtExpiresAt() >= dtNow) {
            headers = new Headers(myCookie.GetJwtHeader());
        }
    }

    let contentType = post.contentType || 'application/json';
    
    headers.append('Content-Type', contentType);
    headers.append('x-app-ver', "insight|102");

    //base url from config
    const api_url = process.env.REACT_APP_API_URL;
    const full_url = api_url + "/2/proxy";
    
    if (!post.method) {
        post.method = "POST"; //this is the method that php will use to relay to dotnet
    }

    const postData = JSON.stringify(post);

    //execute fetch
    const data = await trackPromise(fetch(
        full_url,
        {
            method: 'POST',
            headers: headers,
            body: postData,
            cache: 'no-cache',
            mode: 'cors',
            signal: abort.signal
            
        }));

    if (data.ok) {

        if (data && data.headers && data.headers.get('authorization')) {


            let jwt = data.headers.get('authorization');

            if (jwt) {
                jwt = jwt.replace('Bearer ', '');

                if (myCookie) {
                    myCookie.setJwt(jwt);
                    setSessionCookie(myCookie);
                } else {
                    let newCookie: IUserDataCookie = { jwt: jwt };
                    myCookie = new SessionData(newCookie)
                    setSessionCookie(myCookie);
                }
            }
            
        }
        
        if (contentType === 'application/json') {
            toReturn = await data.json();        
        } else {
            toReturn = await data.text() as any;
        }
    }

    return toReturn;
}

// Had to implement ability to access /1/ api's 
export const APIPostV1 = async <T,>(
    options: {
        endpoint: string,
        authorize: boolean
        method: string
    },
    data: {
        [propName: string]: any
    },
    abort?: AbortController): Promise<T | null> => {

    let dtNow = new Date();
    let myCookie: SessionData | null = getSessionCookie();
    let toReturn: T | null = null;
    let headers = new Headers();

    if (!abort) {
        abort = new AbortController();
    }

    //if needs auth, check jwt expire first
    if (options.authorize) {
        if (!myCookie || myCookie.GetJwtExpiresAt() < dtNow) {
            //should throw a 401 error here.
            return toReturn;
        } else {
            headers = new Headers(myCookie.GetJwtHeader());
        }
    }

    headers.append('Content-Type', 'application/json');

    //base url from config
    const api_url = process.env.REACT_APP_API_URL;
    const full_url = api_url + options.endpoint;
    const postData = JSON.stringify(data);

    //execute fetch
    const promise = await trackPromise(
        fetch(full_url, {
            method: options.method,
            headers: headers,
            body: postData,
            cache: 'no-cache',
            mode: 'cors',
            signal: abort.signal
        })
    );

    if (promise.ok) {
        if (promise && promise.headers && promise.headers.get('authorization')) {
            let jwt = promise.headers.get('authorization');

            if (jwt) {
                jwt = jwt.replace('Bearer ', '');

                if (myCookie) {
                    myCookie.setJwt(jwt);
                    setSessionCookie(myCookie);
                } else {
                    let newCookie: IUserDataCookie = { jwt: jwt };
                    myCookie = new SessionData(newCookie)
                    setSessionCookie(myCookie);
                }
            }
        }

        toReturn = await promise.json();
    }

    return toReturn;
}